import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ToastAlerts from 'components/ToastAlerts';
import FirstTimeOverlay from 'components/FirstTimeOverlay';
import { OrganisationSuspendedModal } from 'components';
import { MainContainer, MainHeaderContainer } from './components';
import { removeAllAlerts } from 'redux/session/actions';
import { currentUser } from 'redux/session/selectors';
import {
  selectCurrentTeamBaseMapToken,
  selectCurrentTeamBaseMapType,
  selectCustomBaseMapSecret,
  selectCustomBaseMapKey
} from 'redux/team/selectors';
import {
  setCurrentTeam,
  setCustomTeamBaseMapCredential,
  getCustomTeamBaseMapTokenStart
} from 'redux/team/actions';
import { getSiteAppsStart } from 'redux/site/actions';
import { useComponentMount } from 'utilities/hooks.util';
export interface PageProps {
  enableHeaderGlobalBar: boolean;
  headerChildren?: React.ReactElement;
  mapStyleClusterHandler?: Function;
  mapStyleClusterVisibleRef?: React.MutableRefObject<boolean>;
  mapStyleShowMasking?: boolean;
  mapStyleShowLegend?: React.ReactElement;
  disableNav?: boolean;
}

/**
 * FULL HEADER, LEFT AND RIGHT PANEL LAYOUT (3 COLUMN)
 */
export const FullHeaderLeftSideFullPanelLayout: React.FC<PageProps> = (
  props: any
) => {
  const {
    disableNav,
    enableHeaderGlobalBar,
    headerChildren,
    mapStyleShowMasking,
    mapStyleShowLegend,
    mapStyleClusterHandler,
    mapStyleClusterVisibleRef
  } = props;

  const dispatch = useDispatch();
  const teamBaseMapToken = useSelector(selectCurrentTeamBaseMapToken);
  const teamBaseMapType = useSelector(selectCurrentTeamBaseMapType);
  const customMapKey = useSelector(selectCustomBaseMapKey);
  const customMapSecret = useSelector(selectCustomBaseMapSecret);
  const user = useSelector(currentUser);

  useEffect(() => {
    if (user) {
      if (user?.default_project && user?.Project?.name) {
        const teamDefaultValues = {
          activity: user.Project.onsite_activity,
          activityId: user.Project.activity_id?.toString(),
          enquiryType: user.Project.job_purpose,
          workingOnBehalf: user.Project.working_on_behalf,
          workingOnBehalfId: user.Project.on_behalf_id?.toString(),
          workingOnBehalfAuthorityName: user.Project.authority_name,
          workingOnBehalfAuthorityId: user.Project.authority_id?.toString(),
          workplaceLocation: user.Project.location_of_workplace,
          locationInRoad: user.Project.location_in_road
        };
        dispatch(
          setCurrentTeam({
            id: user.default_project,
            name: user.Project.name,
            shape: user.Project.shape,
            baseMapType: user.Project.basemap_type,
            baseMapId: user.Project.custom_map_id,
            teamDefaultValues
          })
        );
        if (
          user.Project.basemap_type === 'custom' &&
          user.Project.arcgis_client_key &&
          user.Project.arcgis_client_secret
        ) {
          dispatch(
            setCustomTeamBaseMapCredential({
              key: user.Project.arcgis_client_key,
              secret: user.Project.arcgis_client_secret
            })
          );
        }
      } else {
        dispatch(
          setCurrentTeam({
            id: 0,
            name: '',
            shape: undefined,
            baseMapId: undefined,
            baseMapType: undefined
          })
        );
      }
    }
  }, [dispatch, user]);

  useEffect(() => {
    if (
      teamBaseMapType === 'custom' &&
      customMapKey &&
      customMapSecret &&
      !teamBaseMapToken
    ) {
      dispatch(
        getCustomTeamBaseMapTokenStart({
          key: customMapKey,
          secret: customMapSecret
        })
      );
    }
  }, [
    dispatch,
    teamBaseMapToken,
    teamBaseMapType,
    customMapKey,
    customMapSecret
  ]);

  useComponentMount(() => {
    dispatch(getSiteAppsStart());
    return () => {
      dispatch(removeAllAlerts());
    };
  });

  return props.children ? (
    <div className={`container--wrapper `}>
      <MainHeaderContainer
        disableNav={disableNav}
        enableHeaderGlobalBar={enableHeaderGlobalBar || false}
        mapStyleClusterHandler={mapStyleClusterHandler}
        mapStyleClusterVisibleRef={mapStyleClusterVisibleRef}
        mapStyleShowMasking={mapStyleShowMasking}
        mapStyleShowLegend={mapStyleShowLegend}
      >
        {headerChildren}
      </MainHeaderContainer>
      <MainContainer>{props.children}</MainContainer>
      <ToastAlerts />
      <FirstTimeOverlay />
      <OrganisationSuspendedModal />
    </div>
  ) : null;
};
